module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-complete-item attribute row text-center"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "badge att-field order"
  }, [_vm._v(_vm._s(_vm.order))])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "att-field description"
  }, [_vm._v(_vm._s(_vm.criteria.descricao))])]), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "att-field relevancy"
  }, [_vm._v(_vm._s(_vm.$t(_vm.criteria.relevante != null ? (_vm.criteria.relevante ? 'planoConciliacao.labels.relevante' : 'planoConciliacao.labels.irrelevante') : null)))])]), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "att-field type"
  }, [_vm._v(_vm._s(_vm.criteria.tipoLancamento ? _vm.$t('planoConciliacao.labels.tipoLancamento.' + _vm.criteria.tipoLancamento) : _vm.criteria.categoria.tipo == null ? _vm.$t('planoConciliacao.labels.tipoLancamento.' + _vm.criteria.categoria.tipo) : null))])]), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "att-field status"
  }, [_vm._v(_vm._s(_vm.$t(_vm.criteria.ativo != null ? (_vm.criteria.ativo ? 'planoConciliacao.labels.ativo' : 'planoConciliacao.labels.inativo') : null)))])]), _c('div', {
    staticClass: "col-md-1 pull-right"
  }, [_c('div', {
    staticClass: "att-field buttons"
  }, [_c('button', {
    staticClass: "fa fa-pencil action",
    attrs: {
      "type": "button",
      "title": _vm.btnEditTitle
    },
    on: {
      "click": function($event) {
        return _vm.handleEdit(_vm.criteria)
      }
    }
  }), _c('button', {
    staticClass: "fa fa-times action",
    attrs: {
      "type": "button",
      "disabled": _vm.criteria.criterioEmUso,
      "title": _vm.btnRemoveTitle
    },
    on: {
      "click": function($event) {
        return _vm.handleRemove(_vm.criteria)
      }
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7fa5a10b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fa5a10b"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/registration/conciliationPlan/classificationCriteria/classificationCriteria.pug
// module id = 1447
// module chunks = 0